export const SAVE_USERINFO = 'SAVE_USERINFO' // 会员消息存储
export const CHANGE_WALLET_STATE = 'CHANGE_WALLET_STATE' // 平台公司和会员店 开通激活状态
export const SAVE_REGISTER_RESULT = 'SAVE_REGISTER_RESULT' // 会员店申请结果
export const SAVE_COMPANYCODE = 'SAVE_COMPANYCODE' // 获取会员店code
export const SAVE_MONEY = 'SAVE_MONEY' // 获取支付金额
export const SAVE_ORDER = 'SAVE_ORDER' // 订单信息
export const SAVE_ONCE_PAYMENT_PRICE = 'SAVE_ONCE_PAYMENT_PRICE' // 本次付款订单金额
export const SAVE_MONEYINFO = 'SAVE_MONEYINFO' // 钱包充值信息页面
export const TABREMEMBER = 'TABREMEMBER' // 特价专区tab记忆
// 最新
export const SAVE_MEMBERINFO = 'SAVE_MEMBERINFO' // 存储会员店的信息
export const SAVE_BANKINFO = 'SAVE_BANKINFO' // 银行卡信息
export const GET_USERINFO = 'GET_USERINFO' // 获取会员店信息
export const GET_CARTNUMS = 'GET_CARTNUMS' // 获取购物车数量
export const GET_AREALIST = 'GET_AREALIST' // 获取省市区数据
export const GET_BANK = 'GET_BANK' // 银行卡信息
export const GET_SEARCH_BANK_LIST = 'GET_SEARCH_BANK_LIST' // 模糊搜索银行卡
export const GET_MY_BANK = 'GET_MY_BANK' // 我的所有银行卡
export const GET_ASSETS_USER_INFO = 'GET_ASSETS_USER_INFO' // 我的钱包具体信息
export const GET_BANKCARD_WITHDRAW_LIST = 'GET_BANKCARD_WITHDRAW_LIST' // 提现银行卡列表
export const GET_BANKCARD_CASHIERDESK = 'GET_BANKCARD_CASHIERDESK' // 支付收银台信息
export const GET_OPEN_ACCOUNT_INFO = 'GET_OPEN_ACCOUNT_INFO' // 企业银行开户信息
export const GET_ADDRESS_INFO = 'GET_ADDRESS_INFO' // 获取地址信息
export const GET_ADDRESSLIST_INFO = 'GET_ADDRESSLIST_INFO' // 获取多地址信息
export const GET_PICLIST_INFO = 'GET_PICLIST_INFO' // 报备信息图片
export const GET_COUPON_INFO = 'GET_COUPON_INFO' // 保存获取优惠券的信息
export const GET_COUPON_STATUS = 'GET_COUPON_STATUS' // 判断优惠券是否刷新
// 进入页面时间
export const PAGE_ENTER_TIME = 'PAGE_ENTER_TIME'